import { Link } from "@tanstack/react-router"
import { Button } from "@/components/ui/button"

export function NotFound() {
	return (
		<div className="flex h-[50vh] flex-col items-center justify-center space-y-4">
			<div className="text-center space-y-2">
				<h1 className="text-4xl font-bold">404</h1>
				<h2 className="text-2xl font-semibold">Page Not Found</h2>
				<p className="text-muted-foreground">
					The page you're looking for doesn't exist or has been moved.
				</p>
			</div>

			<Button asChild>
				<Link to="/">Go Home</Link>
			</Button>
		</div>
	)
}
